import React, { useEffect, useState, useRef, useMemo } from "react";
import classes from "./ChartofAcoont.module.css";
import HeaderNav from '../../Budget/Budget Dashboard/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer, Search } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";

const ChartofaCcount = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // State for modals
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);

  // State for form data
  const [accountCode, setAccountCode] = useState("");
  const [glname, setGlname] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedDirection, setSelectedDirection] = useState("");
  const [balance, setBalance] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  // State for edit form data
  const [accountCode1, setAccountCode1] = useState("");
  const [glname1, setGlname1] = useState("");
  const [selectedSubCategory1, setSelectedSubCategory1] = useState("");
  const [selectedDirection1, setSelectedDirection1] = useState("");
  const [balance1, setBalance1] = useState("");
  const [selectedDate1, setSelectedDate1] = useState("");
  const [editingAccountId, setEditingAccountId] = useState(null);

  // State for API data and loading
  const [tableData, setTableData] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]); // Store all accounts for filtering
  const [tableData5, setTableData5] = useState([]); // For account types in add modal (get-sub-categories)
  const [tableData6, setTableData6] = useState([]); // For account types in edit modal (classes)
  const [loading, setLoading] = useState(true); // Changed to true for initial load
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // State for filters
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [selectedProvinceFilter, setSelectedProvinceFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [viewMode, setViewMode] = useState('default');

  // Modal handlers
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleShow1 = () => setShow1(true);
  const handleClose1 = () => setShow1(false);

  // Print view handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/account');
  };

  // Read authentication data
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }

      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Fetch continents from API
  const fetchContinents = async () => {
    try {
      if (!bearer) return;
      setFiltersLoading(true);

      const response = await axios.get(`${BASE_URL}/continents`, { headers });

      if (response.data.status) {
        setContinents(response.data.data || []);
      } else if (Array.isArray(response.data)) {
        setContinents(response.data);
      } else if (response.data.data) {
        setContinents(response.data.data || []);
      } else {
        setContinents([]);
      }
    } catch (error) {
      console.error("Error fetching continents:", error);
      setContinents([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    if (!continentId) {
      setRegions([]);
      return;
    }

    try {
      setFiltersLoading(true);
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });

      let regionsData = [];
      if (response.data.status && response.data.data) {
        if (Array.isArray(response.data.data)) {
          regionsData = response.data.data;
        } else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
          regionsData = response.data.data.regions;
        }
      } else if (Array.isArray(response.data)) {
        regionsData = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        regionsData = response.data.data;
      }

      setRegions(regionsData || []);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Fetch provinces based on selected region
  const fetchProvincesForFilter = async (regionId) => {
    if (!regionId) {
      setProvinces([]);
      return;
    }

    try {
      setFiltersLoading(true);
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`, { headers });

      let provincesData = [];
      if (response.data.status) {
        if (response.data.data && response.data.data.provinces) {
          provincesData = response.data.data.provinces;
        } else if (Array.isArray(response.data.data)) {
          provincesData = response.data.data;
        } else {
          provincesData = response.data.data || [];
        }
      } else if (Array.isArray(response.data)) {
        provincesData = response.data;
      } else if (response.data.data) {
        provincesData = response.data.data || [];
      }

      setProvinces(provincesData || []);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Handle continent filter change
  const handleContinentChange = (selectedOption) => {
    setSelectedContinentFilter(selectedOption);
    setSelectedRegionFilter(null);
    setSelectedProvinceFilter(null);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  // Handle region filter change
  const handleRegionChange = (selectedOption) => {
    setSelectedRegionFilter(selectedOption);
    setSelectedProvinceFilter(null);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  // Handle province filter change
  const handleProvinceChange = (selectedOption) => {
    setSelectedProvinceFilter(selectedOption);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  // Handle search term change
 const handleSearchChange = (e) => {
  const term = e.target.value;
  setSearchTerm(term);
  setCurrentPage(1);

  // Always trigger server-side search when typing
  if (term.trim()) {
    setViewMode('search');
    fetchSearch(1, term.trim());
  } else {
    // If search is completely cleared, return to previous view
    if (selectedProvinceFilter) {
      setViewMode('province');
      handleProcessProvinceAccounts(1);
    } else {
      setViewMode('default');
      fetchChartOfAccounts(1);
    }
  }
};

  // Filter accounts based on selected options and search term
  const filterAccounts = (continent, region, province, searchTerm) => {
    let filtered = [...allAccounts];

    // Filter by continent
    if (continent && continent.value) {
      filtered = filtered.filter(account =>
        account.continent_id === continent.value ||
        account.continent?.id === continent.value
      );
    }

    // Filter by region
    if (region && region.value) {
      filtered = filtered.filter(account =>
        account.region_id === region.value ||
        account.region?.id === region.value
      );
    }

    // Filter by province
    if (province && province.value) {
      filtered = filtered.filter(account =>
        account.province_id === province.value ||
        account.province?.id === province.value
      );
    }

    // Filter by search term
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(account => {
        const accountCode = account.gl_code || "";
        const accountName = account.gl_name || "";
        const accountType = account.class?.description || "";

        return (
          accountCode.toLowerCase().includes(searchLower) ||
          accountName.toLowerCase().includes(searchLower) ||
          accountType.toLowerCase().includes(searchLower)
        );
      });
    }

    // Update pagination
    const total = filtered.length;
    setTotalEntries(total);
    setTotalPages(Math.max(1, Math.ceil(total / entriesPerPage)));

    // Get current page data
    const startIndex = (currentPage - 1) * entriesPerPage;
    const paginatedData = filtered.slice(startIndex, startIndex + entriesPerPage);
    setTableData(paginatedData);
  };

  // Fetch all chart of accounts with pagination
  const fetchChartOfAccounts = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/account/pagination?page=${page}&per_page=${entriesPerPage}`,
        { headers }
      );

      const data = response.data?.data;
      if (data) {
        const accountsData = data.data || [];
        setAllAccounts(accountsData); // Store all accounts for filtering
        setTableData(accountsData);
        setTotalEntries(data.total || 0);
        setTotalPages(data.last_page || 1);
        setCurrentPage(data.current_page || page);
      }
    } catch (error) {
      console.error("Error fetching chart of accounts:", error);
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Error!",
        text: "Failed to fetch chart of accounts",
        confirmButtonText: "Okay"
      });
      setTableData([]);
      setAllAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch account types for ADD modal (get-sub-categories)
  const fetchSubCategories = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/get-sub-categories`, { headers });
      setTableData5(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching sub categories:", error);
    }
  };

  // Fetch account types for EDIT modal (classes)
  const fetchClasses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/account/classes`, { headers });
      setTableData6(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  // useEffect(() => {
  //   if (bearer) {
  //     fetchChartOfAccounts();
  //     fetchSubCategories();
  //     fetchClasses();
  //     fetchContinents();
  //   }
  // }, [bearer]);

    useEffect(() => {
    if (bearer) {
      // Always start with default chart of accounts
      setViewMode('default');
      fetchChartOfAccounts(1);
      fetchSubCategories();
      fetchClasses();
      fetchContinents();
    }
  }, [bearer]);

  // Fetch regions when continent filter changes
  useEffect(() => {
    if (selectedContinentFilter) {
      fetchRegions(selectedContinentFilter.value);
    } else {
      setRegions([]);
      setSelectedRegionFilter(null);
      setSelectedProvinceFilter(null);
    }
  }, [selectedContinentFilter]);

  // Fetch provinces when region filter changes
  useEffect(() => {
    if (selectedRegionFilter) {
      fetchProvincesForFilter(selectedRegionFilter.value);
    } else {
      setProvinces([]);
      setSelectedProvinceFilter(null);
    }
  }, [selectedRegionFilter]);

  // Form handlers
  const handleSubCatChange = (e) => setSelectedSubCategory(e.target.value);
  const handleDirectionChange = (e) => setSelectedDirection(e.target.value);
  const handleDateChange = (e) => setSelectedDate(e.target.value);
  const handleValueChange = (value) => setBalance(value);

  const handleSubCatChange1 = (e) => setSelectedSubCategory1(e.target.value);
  const handleDirectionChange1 = (e) => setSelectedDirection1(e.target.value);
  const handleDateChange1 = (e) => setSelectedDate1(e.target.value);
  const handleValueChange1 = (value) => setBalance1(value);

  // Create account
  const createAccount = async () => {
    setLoading(true);
    try {
      const payload = {
        gl_code: accountCode,
        gl_name: glname,
        sub_category_id: selectedSubCategory,
        direction: selectedDirection,
        // opening_balance: balance || 0,
        // balance_date: selectedDate || new Date().toISOString().split('T')[0]
      };

      const response = await axios.post(
        `${BASE_URL}/account/add`,
        payload,
        { headers }
      );

      Swal.fire({
        imageUrl: verified,
        title: 'Success!',
        text: response.data.message || 'Account created successfully',
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48
      });

      handleClose();
      resetForm();
      fetchChartOfAccounts(currentPage);
    } catch (error) {
      console.error("Error creating account:", error);
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Error!",
        text: error.response?.data?.message || "Failed to create account",
        confirmButtonText: "Okay"
      });
    } finally {
      setLoading(false);
    }
  };

  // Edit account - populate form with existing data
  const handleEdit = (account) => {
    setEditingAccountId(account.id);

    const accountCode = account.gl_code || "";
    const glName = account.gl_name || "";
    const accountType = account.class?.description || "N/A";
    const direction = account.direction || "";
    const balance = account.balance || "0.00";
    const balanceDate = account.created_at ? account.created_at.split('T')[0] : "";

    setAccountCode1(accountCode);
    setGlname1(glName);
    setSelectedSubCategory1(accountType);
    setSelectedDirection1(direction);
    setBalance1(balance);
    setSelectedDate1(balanceDate);

    handleShow1();
  };

  // Update account
  const updateAccount = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/account/update-account-new`,
        {
          id: editingAccountId,
          sub_category_id: selectedSubCategory1,
          gl_name: glname1,
          gl_code: accountCode1,
          direction: selectedDirection1,
        },
        { headers }
      );

      Swal.fire({
        imageUrl: verified,
        title: 'Success!',
        text: response.data.message || 'Account updated successfully',
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48
      });

      fetchChartOfAccounts(currentPage);
      handleClose1();
      resetEditForm();

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Error!",
        text: errorMessage,
        confirmButtonText: "Okay"
      });

      console.log(error);
    } finally {
      setLoading(false);
    }
  };




  // Process button handler for province accounts
  const handleProcessProvinceAccounts = async (page = 1) => {
  if (!selectedProvinceFilter) {
    Swal.fire({
      title: "Selection Required",
      text: "Please select continent, region and province to process accounts.",
      icon: "info",
      confirmButtonText: "OK",
    });
    return;
  }

  // 🔥 This is the key addition
  setViewMode('province'); // Now the app knows we're viewing province-specific data

  try {
    setIsLoading(true);

    const response = await axios.get(
      `${BASE_URL}/provinces/get-province-account-pagination?province_id=${selectedProvinceFilter.value}&page=${page}&per_page=${entriesPerPage}`,
      { headers }
    );

    console.log("PROVINCE ACCOUNTS API RESPONSE:", response.data);

    if (response.data.status && response.data.data) {
      const accountsData = response.data.data.data || [];
      const paginationInfo = response.data.data;

      setTableData(accountsData);
      setTotalEntries(paginationInfo.total || accountsData.length);
      setTotalPages(paginationInfo.last_page || 1);
      setCurrentPage(paginationInfo.current_page || page);

      // Swal.fire({
      //   title: "Success!",
      //   text: `Loaded ${accountsData.length} province accounts for ${selectedProvinceFilter.label}`,
      //   icon: "success",
      //   confirmButtonText: "OK",
      // });
    } else {
      // Fallback handling
      const accountsData = response.data.data || [];
      setTableData(accountsData);
      setTotalEntries(accountsData.length);
      setTotalPages(1);
      setCurrentPage(1);

      // Swal.fire({
      //   title: "Success!",
      //   text: `Loaded ${accountsData.length} province accounts for ${selectedProvinceFilter.label}`,
      //   icon: "success",
      //   confirmButtonText: "OK",
      // });
    }
  } catch (error) {
    console.error("Error processing province accounts:", error);
    Swal.fire({
      title: "Error!",
      text: error.response?.data?.message || "Failed to load province accounts",
      icon: "error",
      confirmButtonText: "OK",
    });
    setTableData([]);
    setTotalEntries(0);
    setTotalPages(1);
    setCurrentPage(1);
  } finally {
    setIsLoading(false);
  }
};

const fetchSearch = async (page = 1, term = searchTerm) => {
  if (!term.trim()) {
    // Safety: if no term, don't search
    setTableData([]);
    setTotalEntries(0);
    setTotalPages(1);
    setCurrentPage(1);
    return;
  }

  try {
    setIsLoading(true);
    const response = await axios.get(
      `${BASE_URL}/account/search-chart-of-accounts`,
      {
        headers,
        params: {
          // page,
          variable: term.trim(),
          // per_page: entriesPerPage, 
        },
      }
    );

    if (response.data?.status && response.data?.data) {
      const accountsData = response.data.data || [];
      const paginationInfo = response.data.data;

      setTableData(accountsData);
      setTotalEntries(paginationInfo.total || 0);
      setTotalPages(paginationInfo.last_page || 1);
      setCurrentPage(paginationInfo.current_page || page);
    } else {
      setTableData([]);
      setTotalEntries(0);
      setTotalPages(1);
      setCurrentPage(1);
    }
  } catch (error) {
    console.error("Search error:", error);
    Swal.fire({
      title: "Error!",
      text: error.response?.data?.message || "Failed to search accounts",
      icon: "error",
      confirmButtonText: "OK",
    });
    setTableData([]);
    setTotalEntries(0);
    setTotalPages(1);
    setCurrentPage(1);
  } finally {
    setIsLoading(false);
  }
};

  // Pagination handlers
  const handlePrevPage = () => {
  if (currentPage > 1) {
    const newPage = currentPage - 1;
    setCurrentPage(newPage);

    if (viewMode === 'search' && searchTerm.trim()) {
      fetchSearch(newPage, searchTerm.trim());
    } else if (viewMode === 'province' && selectedProvinceFilter) {
      handleProcessProvinceAccounts(newPage);
    } else {
      fetchChartOfAccounts(newPage);
    }
  }
};

const handleNextPage = () => {
  if (currentPage < totalPages) {
    const newPage = currentPage + 1;
    setCurrentPage(newPage);

    if (viewMode === 'search' && searchTerm.trim()) {
      fetchSearch(newPage, searchTerm.trim());
    } else if (viewMode === 'province' && selectedProvinceFilter) {
      handleProcessProvinceAccounts(newPage);
    } else {
      fetchChartOfAccounts(newPage);
    }
  }
};

const handlePageClick = (page) => {
  setCurrentPage(page);

  if (viewMode === 'search' && searchTerm.trim()) {
    fetchSearch(page, searchTerm.trim());
  } else if (viewMode === 'province' && selectedProvinceFilter) {
    handleProcessProvinceAccounts(page);
  } else {
    fetchChartOfAccounts(page);
  }
};

 const handleShowAllAccounts = () => {
    setSelectedContinentFilter(null);
    setSelectedRegionFilter(null);
    setSelectedProvinceFilter(null);
    setSearchTerm("");
    setCurrentPage(1);
    setViewMode('default');
    fetchChartOfAccounts(1);
  };

  const handleDelete = async (accountId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.get(`${BASE_URL}/account/delete?id=${accountId}`, { headers });

        Swal.fire({
          imageUrl: verified,
          title: 'Deleted!',
          text: response.data.message || 'Account has been deleted.',
          confirmButtonText: "Okay",
          imageWidth: 48,
          imageHeight: 48
        });

        fetchChartOfAccounts(currentPage);
      } catch (error) {
        let errorMessage = "An error occurred. Please try again.";
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }

        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Error!",
          text: errorMessage,
          confirmButtonText: "Okay"
        });

        console.log(error);
      }
    }
  };

  // Reset forms
  const resetForm = () => {
    setAccountCode("");
    setGlname("");
    setSelectedSubCategory("");
    setSelectedDirection("");
    setBalance("");
    setSelectedDate("");
  };

  const resetEditForm = () => {
    setAccountCode1("");
    setGlname1("");
    setSelectedSubCategory1("");
    setSelectedDirection1("");
    setBalance1("");
    setSelectedDate1("");
    setEditingAccountId(null);
  };

  // Calculate pagination indices
  const startIndex = (currentPage - 1) * entriesPerPage + 1;
  const endIndex = Math.min(currentPage * entriesPerPage, totalEntries);

  // Prepare options for react-select
  const continentOptions = Array.isArray(continents)
    ? continents.map(continent => ({
      value: continent.id,
      label: continent.description || 'Unnamed Continent'
    }))
    : [];

  const regionOptions = Array.isArray(regions)
    ? regions.map(region => ({
      value: region.id,
      label: region.description || 'Unnamed Region'
    }))
    : [];

  const provinceOptions = Array.isArray(provinces)
    ? provinces.map(province => ({
      value: province.id,
      label: province.description || 'Unnamed Province'
    }))
    : [];

  const safeRender = (value) => {
    if (value === null || value === undefined) {
      return "N/A";
    }
    if (typeof value === 'string' || typeof value === 'number') {
      return value;
    }
    if (typeof value === 'object') {
      if (value.description) return value.description;
      if (value.name) return value.name;
      if (value.id) return value.id;
      return "";
    }
    return String(value);
  };

  // Pagination component
  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`${classes.pageButton} ${currentPage === i ? classes.activePage : ''}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className={classes.paginationContainer}>
        <div className={classes.paginationControls}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className={classes.pageButton}
          >
            Previous
          </button>

          {pages}

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={classes.pageButton}
          >
            Next
          </button>

          <span className={classes.pageText}>
            Displaying {startIndex} - {endIndex} of {totalEntries}
          </span>
        </div>
      </div>
    );
  };

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Chart of Accounts</h2>
          <h1 className={classes.Titles}>
            Manage your company's account structure and view account balances.
          </h1>
        </header>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input
                type="text"
                className={classes.searchBar}
                placeholder="Search accounts"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>

            {/* Continent Dropdown with skeleton */}
            <div className={classes.selectWrapper} style={{ width: '200px' }}>
              {filtersLoading && continents.length === 0 ? (
                <Skeleton height={40} borderRadius={8} />
              ) : (
                <Select
                  value={selectedContinentFilter}
                  onChange={handleContinentChange}
                  options={continentOptions}
                  placeholder="Select Continent"
                  isClearable
                  className={classes.filterSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '40px',
                      fontSize: '14px'
                    })
                  }}
                />
              )}
            </div>

            {/* Region Dropdown with skeleton */}
            <div className={classes.selectWrapper} style={{ width: '180px' }}>
              {filtersLoading && selectedContinentFilter && regions.length === 0 ? (
                <Skeleton height={40} borderRadius={8} />
              ) : (
                <Select
                  value={selectedRegionFilter}
                  onChange={handleRegionChange}
                  options={regionOptions}
                  placeholder="Select Region"
                  isClearable
                  isDisabled={!selectedContinentFilter}
                  className={classes.filterSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '40px',
                      fontSize: '14px'
                    })
                  }}
                />
              )}
            </div>

            {/* Province Dropdown with skeleton */}
            <div className={classes.selectWrapper} style={{ width: '180px' }}>
              {filtersLoading && selectedRegionFilter && provinces.length === 0 ? (
                <Skeleton height={40} borderRadius={8} />
              ) : (
                <Select
                  value={selectedProvinceFilter}
                  onChange={handleProvinceChange}
                  options={provinceOptions}
                  placeholder="Select Province"
                  isClearable
                  isDisabled={!selectedRegionFilter}
                  className={classes.filterSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '40px',
                      fontSize: '14px'
                    })
                  }}
                />
              )}
            </div>

            {/* Process Button */}
            <button
              className={classes.btnss}
              onClick={() => handleProcessProvinceAccounts(1)}
              disabled={!selectedProvinceFilter || isLoading}
              style={{
                marginLeft: '10px',
                opacity: (!selectedProvinceFilter) ? 0.6 : 1
              }}
            >
              {isLoading ? <Spinner size="sm" /> : "Process"}
            </button>
          </div>

          <div className={classes.btnfav}>
            <button className={classes.btnss} onClick={handlePrintView}>
              <Printer size={16} style={{ marginRight: "8px", marginBottom: "-3px" }} />
              Print View
            </button>

            <div className={classes.actionsLeft}>
              <button className={classes.btnss} onClick={handleShow}>
                + New Account
              </button>
            </div>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead style={{ whiteSpace: "nowrap" }}>
              <tr>
                <th>S/N</th>
                <th>Account Code</th>
                <th>Account Name</th>
                <th>Type</th>
                <th>Category</th>
                <th>Sub-Category</th>
                <th>Created by</th>
                <th>Created Date</th>
                <th>Direction</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                // Initial loading skeleton
                Array.from({ length: 10 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <Skeleton height={20} width={20} circle />
                        <Skeleton height={20} width={20} circle />
                      </div>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                // Processing/filter loading skeleton
                Array.from({ length: 6 }).map((_, idx) => (
                  <tr key={`processing-${idx}`}>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td><Skeleton height={20} borderRadius={4} /></td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <Skeleton height={20} width={20} circle />
                        <Skeleton height={20} width={20} circle />
                      </div>
                    </td>
                  </tr>
                ))
              ) : !Array.isArray(tableData) || tableData.length === 0 ? (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center", padding: "20px" }}>
                    {selectedProvinceFilter
                      ? `No province accounts found for ${selectedProvinceFilter.label}`
                      : "No accounts found."}
                  </td>
                </tr>
              ) : (
                tableData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{startIndex + index}</td>
                    <td>{item.gl_code || "N/A"}</td>
                    <td>{item.gl_name || "N/A"}</td>
                    <td>{item.class?.description || "N/A"}</td>
                    <td>{item.category?.description || "N/A"}</td>
                    <td>{item.subcategory?.description || "N/A"}</td>
                    <td>{item.created_by?.name || "N/A"}</td>
                    <td>{item.created_at ? new Date(item.created_at).toLocaleDateString() : "N/A"}</td>
                    <td>{item.direction === "1" ? "DR" : item.direction === "2" ? "CR" : "N/A"}</td>
                    <td className={classes.actions}>
                      <Pen
                        size={16}
                        className={classes.editIcon}
                        onClick={() => handleEdit(item)}
                        style={{ cursor: 'pointer' }}
                      />
                      <Trash2
                        size={16}
                        className={classes.deleteIcon}
                        onClick={() => handleDelete(item.id)}
                        style={{ cursor: 'pointer' }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination with skeleton */}
          {loading ? (
            <div className={classes.paginationContainer}>
              <Skeleton height={40} width={400} borderRadius={8} />
            </div>
          ) : totalPages > 1 ? (
            renderPagination()
          ) : null}
        </div>
      </div>

      {/* Create Account Modal */}
      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Create Chart Of Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label style={{ marginTop: 20 }}>Account Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Code"
                value={accountCode}
                onChange={(e) => setAccountCode(e.target.value)}
              />

              <Form.Label style={{ marginTop: 20 }}>Gl Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Gl Name"
                value={glname}
                onChange={(e) => setGlname(e.target.value)}
              />

              <Form.Label style={{ marginTop: 20 }}>Account Type</Form.Label>
              <Form.Select
                className="form-control"
                as="select"
                value={selectedSubCategory}
                onChange={handleSubCatChange}
                style={{ fontSize: '12px' }}
              >
                <option value="" disabled>Select Type</option>
                {tableData5.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.description}
                  </option>
                ))}
              </Form.Select>

              <Form.Label style={{ marginTop: 20 }}>Direction</Form.Label>
              <Form.Select
                className="form-control"
                as="select"
                value={selectedDirection}
                onChange={handleDirectionChange}
              >
                <option value="" disabled>Select Direction</option>
                <option value="1">Debit</option>
                <option value="2">Credit</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button variant="success" onClick={createAccount} style={{ backgroundColor: '#103265', borderColor: '#103265' }}>
            {loading ? (
              <>
                <Spinner size='sm' />
                <span style={{ marginLeft: '5px' }}>Creating account, Please wait...</span>
              </>
            ) : (
              "Create"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Account Modal */}
      <Modal show={show1} onHide={handleClose1} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Chart Of Accounts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label style={{ marginTop: 20 }}>Account Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Code"
                value={accountCode1}
                onChange={(e) => setAccountCode1(e.target.value)}
              />

              <Form.Label style={{ marginTop: 20 }}>Gl Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Gl Name"
                value={glname1}
                onChange={(e) => setGlname1(e.target.value)}
              />

              <Form.Label style={{ marginTop: 20 }}>Account Type</Form.Label>
              <Form.Control
                type="text"
                value={selectedSubCategory1}
                readOnly
                style={{ backgroundColor: '#f8f9fa' }}
              />

              <Form.Label style={{ marginTop: 20 }}>Direction</Form.Label>
              <Form.Select
                className="form-control"
                as="select"
                value={selectedDirection1}
                onChange={handleDirectionChange1}
              >
                <option value="" disabled>Select Direction</option>
                <option value="1">Debit</option>
                <option value="2">Credit</option>
              </Form.Select>

              <Form.Label style={{ marginTop: 20 }}>Opening Balance</Form.Label>
              <br />
              <CurrencyInput
                id="exampleForm.ControlInput1"
                name="Balance"
                placeholder="Enter Opening balance"
                decimalsLimit={2}
                value={balance1}
                onValueChange={handleValueChange1}
                style={{
                  minWidth: "100%",
                  height: "calc(1.8em + .75rem + 2px)",
                  border: '1px solid #e4e5e7',
                  borderRadius: 5,
                  overflow: 'hidden',
                  zIndex: 999,
                  fontSize: 14,
                  padding: ".375rem .75rem"
                }}
              />

              <Form.Label style={{ marginTop: 20 }}>Balance as at</Form.Label>
              <input
                className="form-control"
                required=""
                type="date"
                onChange={handleDateChange1}
                name="date"
                value={selectedDate1}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose1}>
            Go back
          </Button>
          <Button
            variant="success"
            onClick={updateAccount}
            style={{ backgroundColor: '#103265', borderColor: '#103265' }}
          >
            {loading ? (
              <Spinner animation="border" variant="warning" size="sm" />
            ) : (
              'Save Changes'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Footer /> */}
    </div>
  );
};

export default ChartofaCcount;